import { z } from 'zod';
import { listResponse } from '../../utils/listResponse';
import { groupSchema } from '../models/group.schema';

export const list = () => {
  return {
    endpoint: `/groups`,
    method: 'GET',
    responseSchema: listResponse(groupSchema),
    query: { includeTotal: true },
    querySchema: z.object({ includeTotal: z.boolean().optional() }),
  } as const;
};
